import { css, Mode, styled } from 'canoe';

export const Nav = styled.div<{ numOfTabs: number; mode: Mode }>`
  ${({ theme, numOfTabs, mode }) => css`
    display: grid;
    grid-template-columns: repeat(${numOfTabs}, minmax(100px, calc(100% / ${numOfTabs})));
    text-align: center;
    height: 40px;
    flex-shrink: 0;

    ${mode === 'Dark'
      ? css`
          border-top: 1px solid ${theme.colors.OnyxGrayD20};
        `
      : css`
          border-top: 1px solid ${theme.colors.GlitterGray};
        `}
  `}
`;

export const NavItem = styled.div<{ active: boolean; disabled: boolean; mode: Mode }>`
  ${({ theme, active, disabled, mode }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid ${theme.colors.GlitterGray};

    ${mode === 'Dark'
      ? css`
          border-right: 1px solid ${theme.colors.OnyxGrayD20};

          ${!active &&
          css`
            background: ${theme.colors.OnyxGrayD10};
            border-bottom: 1px solid ${theme.colors.OnyxGrayD20};
          `}
        `
      : css`
          border-right: 1px solid ${theme.colors.GlitterGray};

          ${!active &&
          css`
            background: ${theme.colors.GlitterGrayL20};
            border-bottom: 1px solid ${theme.colors.GlitterGray};
          `}
        `}

    &:hover {
      ${disabled
        ? css`
            cursor: not-allowed;
          `
        : css`
            cursor: pointer;
          `}
    }
  `}
`;
